// src/services/storageService.js

const StorageType = {
  LOCAL: "localStorage",
  SESSION: "sessionStorage"
};

const isBrowser = typeof window !== "undefined";

const getStorage = (type = StorageType.LOCAL) => {
  if (!isBrowser) return null;
  return type === StorageType.SESSION ? window.sessionStorage : window.localStorage;
};

const storageService = {
  set: (key, value, type = StorageType.LOCAL) => {
    const storage = getStorage(type);
    if (!storage) return;
    try {
      const serialized = typeof value === "string" ? value : JSON.stringify(value);
      storage.setItem(key, serialized);
    } catch (error) {
      console.error(`Error saving ${key} to ${type}:`, error);
    }
  },

  get: (key, type = StorageType.LOCAL) => {
    const storage = getStorage(type);
    if (!storage) return null;
    try {
      const item = storage.getItem(key);
      if (!item) return null;
      return JSON.parse(item);
    } catch {
      return storage.getItem(key); // fallback if not JSON
    }
  },

  remove: (key, type = StorageType.LOCAL) => {
    const storage = getStorage(type);
    if (storage) {
      storage.removeItem(key);
    }
  },

  clear: (type = StorageType.LOCAL) => {
    const storage = getStorage(type);
    if (storage) {
      storage.clear();
    }
  },

  has: (key, type = StorageType.LOCAL) => {
    const storage = getStorage(type);
    return storage ? storage.getItem(key) !== null : false;
  }
};

export default storageService;
export { StorageType };
